import React from 'react';
import SubBody from "../../../application/general/components/common/SubBody";
import { Input, InputNumber, Select } from "antd";
import { Option } from "antd/es/mentions";
import { t } from "i18next";
import DG_FormItem_LabelDetail from "../../../../../custom/data-entry/form/Item/LabelDetail";
import DG_InputNumber_Money from "../../../../../custom/data-entry/input-number/Money";

const Other = props => {

    const onchangeAuto = (value) => {
        if (value === "auto") {
            props.onChangeClosing(true)
        } else if (value === "handmade") {
            props.onChangeClosing(false)
        }
    }
    return (
        <div className={'px-8 py-3'}>

            <SubBody>
                <DG_FormItem_LabelDetail
                    label={t("timeKeeping-setting.timeKeeping-setting.other-settings.line-split")}
                    labelDetail={t("timeKeeping-setting.timeKeeping-setting.other-settings.line-split-detail")}
                    name={"splitline"}
                >
                    <Select
                        mode="single"
                        maxTagCount={1}
                        style={{ textAlign: "left" }}
                        defaultActiveFirstOption={true}
                    >
                        <Option value="no separation">
                            {t("timeKeeping-setting.timeKeeping-setting.other-settings.line-split-select.not-line-split")}
                        </Option>
                        <Option value="by location department">
                            {t("timeKeeping-setting.timeKeeping-setting.other-settings.line-split-select.position-line-split")}
                        </Option>
                    </Select>
                </DG_FormItem_LabelDetail>


                <DG_FormItem_LabelDetail
                    label={t("timeKeeping-setting.timeKeeping-setting.other-settings.rounding-factor")}
                    labelDetail={t("timeKeeping-setting.timeKeeping-setting.other-settings.rounding-factor-detail")}
                    name={"roundingFactor"}
                >
                    <Select
                        allowClear
                        optionFilterProp="children"
                    >
                        <Option value="no">{t("tnp.components.timekeeping.text25")}</Option>
                        <Option value="four">0.125</Option>
                        <Option value="three">0.25</Option>
                        <Option value="two">0.5</Option>
                        <Option value="one">1</Option>
                    </Select>

                </DG_FormItem_LabelDetail>


                <DG_FormItem_LabelDetail
                    label={t("tnp.components.timekeeping.text26")}
                    labelDetail={t("tnp.components.timekeeping.text27")}
                    name={"roundingMinuteLate"}
                >
                    <InputNumber
                        style={{ width: '100%' }}
                        min={0}
                        formatter={value => `${value}`.replace(/[^-?\d*$]/g, '')}
                        parser={(value) => {
                            const reg = /^-?\d*$/;
                            if (!isNaN(value) && reg.test(value)) {
                                return value;
                            }
                        }}
                        onKeyDown={(e) => {
                            if (isNaN(parseInt(e.key)) && e.key !== 'Backspace'
                                && e.key !== 'ArrowLeft' && e.key !== 'ArrowRight'
                                && e.key !== 'ArrowUp' && e.key !== 'ArrowDown') {
                                e.preventDefault();
                            }
                        }}
                        placeholder={t("tnp.components.timekeeping.roundingMinutePlaceholder")}
                    />
                </DG_FormItem_LabelDetail>


                <DG_FormItem_LabelDetail
                    label={t("tnp.components.timekeeping.text28")}
                    labelDetail={t("tnp.components.timekeeping.text29")}
                    name={"roundingMinuteSoon"}
                >
                    <InputNumber
                        style={{ width: '100%' }}
                        min={0}
                        formatter={value => `${value}`.replace(/[^-?\d*$]/g, '')}
                        parser={(value) => {
                            const reg = /^-?\d*$/;
                            if (!isNaN(value) && reg.test(value)) {
                                return value;
                            }
                        }}
                        onKeyDown={(e) => {
                            if (isNaN(parseInt(e.key)) && e.key !== 'Backspace'
                                && e.key !== 'ArrowLeft' && e.key !== 'ArrowRight'
                                && e.key !== 'ArrowUp' && e.key !== 'ArrowDown') {
                                e.preventDefault();
                            }
                        }}
                        placeholder={t("tnp.components.timekeeping.roundingMinutePlaceholder")}
                    />
                </DG_FormItem_LabelDetail>

                <DG_FormItem_LabelDetail
                    label={t("timeKeeping-setting.timeKeeping-setting.other-settings.advance-work-day")}
                    labelDetail={t("timeKeeping-setting.timeKeeping-setting.other-settings.advance-work-day-detail")}
                    name={"advanceWorkDay"}
                >
                    <Select
                        allowClear
                        optionFilterProp="children"
                    >
                        <Option value="no">{t("tnp.components.timekeeping.text30")}</Option>
                        <Option value="yes">{t("tnp.components.timekeeping.text31")}</Option>

                    </Select>
                </DG_FormItem_LabelDetail>
                {/*<DG_FormItem_LabelDetail*/}
                {/*    label={t("timeKeeping-setting.timeKeeping-setting.other-settings.single-word-latch")}*/}
                {/*    labelDetail={t("timeKeeping-setting.timeKeeping-setting.other-settings.single-word-latch-detail")}*/}
                {/*    name={"wordLatch"}*/}
                {/*>*/}
                {/*    <Select*/}
                {/*        onChange={onchangeAuto}*/}
                {/*        allowClear*/}
                {/*        optionFilterProp="children"*/}
                {/*        defaultValue="handmade"*/}
                {/*    >*/}
                {/*        <Option value="handmade">{t("tnp.components.timekeeping.text32")}</Option>*/}
                {/*        <Option value="auto">{t("tnp.components.timekeeping.text33")}</Option>*/}
                {/*    </Select>*/}
                {/*</DG_FormItem_LabelDetail>*/}
                {/*{props.closing &&*/}
                {/*    <div>*/}
                {/*        <DG_FormItem_LabelDetail*/}
                {/*            label={t("tnp.components.timekeeping.text34")}*/}
                {/*            labelDetail={t("tnp.components.timekeeping.text35")}*/}
                {/*            name={"closingDate"}*/}
                {/*        >*/}
                {/*            <InputNumber controls={false} min={1} max={31} className={"width--100pc"}/>*/}
                {/*        </DG_FormItem_LabelDetail>*/}
                {/*    </div>*/}
                {/*}*/}
            </SubBody>

        </div>
    );
};

Other.propTypes = {};

export default Other;
